// redux/actionDispatcher/categoryDispatcher.js
// export const addCategoryRequest = (data) => {
//     return {
//       type: "ADD_CATEGORY_REQUEST",
//       payload: data,
//     };
//   };

import { ApiURLs } from "../../../constant/ApiUrls";
import { deleteData, fetchData, postData, postMultipleData, updateData, uploadImage } from "../../../services/api";
import { hideAddAttributeModal } from "./attributeModalDispatcher";

  

  export const addAttributeRequest = (data) => {
    console.log("add attributes request------------------------");
    return async (dispatch) => {
  
      // dispatch();
      dispatch({"type":"ADD_CATEGORY_REQUEST"});
      try {
  
        // if (data.image) {
        //   var uploadedImage = await uploadImage(
        //     ApiURLs.UPLOAD_IMAGE, "image",
  
        //     data.image,
        //     "category"
        //   );
        //   console.log(`upload image function response ${JSON.stringify(uploadedImage)}`)
        //   data.image = uploadedImage.data.file.path
        // }
        // if(data.id){

        // }
        var categoryResponse = await postMultipleData(data, ApiURLs.ATTRIBUTE);// (data.id)? await updateData(data, `${ApiURLs.ATTRIBUTE}/${data.id}`):await postData(data, ApiURLs.ATTRIBUTE);
        // if (categoryResponse.status === 1) {
          dispatch({"type":"ADD_CATEGORY_SUCCESS"});
          dispatch(hideAddAttributeModal()); 
          dispatch(categoryLisitingRequest(data[0]['category_id']));
        // } else {
        //   dispatch({"type":"ADD_CATEGORY_FAILED"});
        // }
      } catch (error) {
        dispatch({"type":"ADD_CATEGORY_FAILED"});
  
      }
    };
  };




  export const categoryLisitingRequest = (parentId, loadCategoryDetails=false) => {
    // console.log('000000000000000000',sortField,sortOrder);

    return async (dispatch) => {



      if(parentId!=0 && loadCategoryDetails==true){
        const url1 = `${ApiURLs.CATEGORIES}?id=${parentId}`;  
        try {
          var categoryResponse = await fetchData(url1);
          dispatch({"type":"GOT_CATEGORY_DETAIL", "payload":categoryResponse.data.result[0]});
          console.log("category response-------", categoryResponse);
        }
        catch(e){

        }
      }
      else{
        console.log("000000000000000000000", parentId, loadCategoryDetails);
        if(parentId==0){
          dispatch({"type":"GOT_CATEGORY_DETAIL", "payload":null});
        }
        else{
          
        }
      }
      // const url = ApiURLs.GET_USERS;
      // const url = `${ApiURLs.CATEGORIES}?parent_id=${parentId}`;
      const url = `${ApiURLs.ATTRIBUTE}?category_id=${parentId}`;  
      console.log(`response when we try to get attribute ${url}`)

      // wait untill the data not received so getData function take data and url part
      dispatch({"type":"GET_CATEGORY_REQUEST"});
      try {
        var userResData = await fetchData(url);
        console.log(`response when we try to get attribute ${JSON.stringify(userResData)}`)
        if (userResData.status === 1) {
          dispatch({"type":"GET_CATEGORY_REQUEST_SUCCESS", "payload":userResData.data.result});
        
        } else {
          dispatch({"type":"GET_CATEGORY_REQUEST_FAILED"});
        }
      } catch (error) {
        dispatch({"type":"GET_CATEGORY_REQUEST_FAILED"});
        console.log(`error while try to get attribute ${error}`)
      }
    }
  };



  export const getSubcategoriesRequest = (categoryId) => {
    return async (dispatch) => {
      dispatch({ type: "GET_SUBCATEGORY_REQUEST", payload: categoryId });
  
      try {
        const url = `${ApiURLs.CATEGORIES}?categoryId=${categoryId}`;
        var subcategoryRes = await fetchData(url);
  
        if (subcategoryRes.status === 1) {
          dispatch({
            type: "GET_SUBCATEGORY_SUCCESS",
            payload: { categoryId, subcategories: subcategoryRes.data.result },
          });
        } else {
          dispatch({
            type: "GET_SUBCATEGORY_FAILED",
            payload: categoryId,
          });
        }
      } catch (error) {
        dispatch({
          type: "GET_SUBCATEGORY_FAILED",
          payload: categoryId,
        });
        console.log(`Error while fetching subcategories: ${error}`);
      }
    };
  };




  export const deleteCategory = (id, parentId) => {
    return async (dispatch) => {
  
      // dispatch();
      dispatch({"type":"ADD_CATEGORY_REQUEST"});
      try {
  

        var categoryResponse = await deleteData(`${ApiURLs.ATTRIBUTE}/${id}`);
        if (categoryResponse.status === 1) {
          dispatch({"type":"ADD_CATEGORY_SUCCESS"});
          dispatch(categoryLisitingRequest(parentId));
        } else {
          dispatch({"type":"ADD_CATEGORY_FAILED"});
        }
      } catch (error) {
        dispatch({"type":"ADD_CATEGORY_FAILED"});
  
      }
    };
  };


  

